import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';

/**
 * UserProfile Schema
 * Per-user-per-organization profile answers. The shape of `info` is
 * defined by `organization.settings.profileFields[].fieldId` so the
 * server treats it as an opaque map (mixed).
 */
export const UserProfileSchema = z.object({
  _id: objectId,
  user: objectId,
  organization: objectId,
  info: z.any().optional(),
  ...timestampFields,
});

export type UserProfile = z.infer<typeof UserProfileSchema>;

export const userProfileMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  user: { ref: 'User', label: 'User' },
  organization: { ref: 'Organization', label: 'Organization' },
  info: { label: 'Info', hidden: true },
  created: { hidden: true },
  updated: { hidden: true },
};
